import { render, staticRenderFns } from "./DetailsDrawer.vue?vue&type=template&id=2ee1ab62&"
import script from "./DetailsDrawer.vue?vue&type=script&lang=js&"
export * from "./DetailsDrawer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "DetailsDrawer.vue"
export default component.exports